import { isFunction } from 'lodash'

const table2Text = '当前组件为table2，不支持该方法'

export const EMPTY_FUNC = function (info) {
  const { methodsName, message } = info || {}
  let mes = ''
  if (methodsName && message) {
    mes = `【${methodsName}】${message}`
  }
  mes && console.error(mes)
}

function injectQueryTableToKyeTable2Wrap(vm) {
  const notSupported = [
    {
      methodsName: 'setCanvasHeight',
      message: '',
    },
    {
      methodsName: 'repaint',
      message: table2Text,
    },
  ]
  notSupported.forEach(item => {
    const { methodsName } = item
    _defineProperty(vm, methodsName, { get: EMPTY_FUNC.bind({}, item) })
  })
}

function injectEmptyEvents(tableProxyObj) {
  const emptyMethods = [
    {
      methodsName: 'setHeaderTipContent',
      message: table2Text,
    },
    {
      methodsName: 'setTableColumns',
      message: table2Text,
    },
    {
      methodsName: 'loadLocalData',
      message: table2Text,
    }
  ]
  emptyMethods.forEach(item => {
    const { methodsName } = item
    _defineProperty(tableProxyObj, methodsName, { get: EMPTY_FUNC.bind({}, item) })
  })
}

function injectQueryTableToVirtualTableAttrs(tableProxyObj, vm) {
  const methodMaps = {
    'loadLocalData': {
      callFn: EMPTY_FUNC
    },
    'tableData': {
      callFn: vm.getTableData
    },
    'clearHScroll': {
      callFn: () => {
        const { clearHScroll } = vm.$props || {}
        const { tableConfig } = vm.$props
        const { option = {} } = tableConfig
        const _clearHScroll = !((clearHScroll === false || option.clearHScroll === false))
        _clearHScroll && vm.scrollToTop()
      }
    },
    'toggleRowSelection': {
      callFn: vm.toggleRowSelection
    },
    'setTableColumns': {
      callFn: vm.setTableColumns
    },
    'flatData': {
      callFn: vm.getTableData,
      isAttrs: true
    }
  }
  Object.keys(methodMaps).forEach(qtMethodKeyName => {
    const { callFn, isAttrs } = methodMaps[qtMethodKeyName]
    const virtualTableMethod = tableProxyObj[qtMethodKeyName]
    _defineProperty(tableProxyObj, qtMethodKeyName, {
      get: callFn || virtualTableMethod || EMPTY_FUNC,
      isAttrs
    })
  })
}

export function injectQueryTableCallMethods(vm) {
  // 代理不需要处理的事件
  injectEmptyEvents(vm.$refs.table)
  // 代理query-table => virtual-table的事件
  injectQueryTableToVirtualTableAttrs(vm.$refs.table, vm)
  // 代理query-table => table2-wrap的事件
  injectQueryTableToKyeTable2Wrap(vm)
}

function _defineProperty(target, keyName, opt) {
  let { get, set, val, isAttrs } = opt
  if (!get || !set) val = target[keyName]
  Object.defineProperty(target, keyName, {
    get() {
      // 手动执行获取代理属性
      if (isAttrs && isFunction(get)) {
        return get()
      }
      return get || val
    },
    set(newValue) {
      if (set) {
        set(newValue)
      } else {
        val = newValue
      }
    },
    enumerable: true,
    configurable: true,
  })
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/proxy.js